import React from 'react'
import GoogleReviews from '../components/GoogleReviews'

const Testimonials: React.FC = () => {
  return <GoogleReviews />
}

export default Testimonials
